import DatePickerCalendarMonthLayout from "./DatePickerCalendarMonthLayout.vue";
import { DateValue } from "@/components/tableElements";
import DatePickerCalendarMixin from "../mixins/DatePickerCalendarMixin.vue";
import { DATE_PICKER_COMPARE_TITLES } from "@/utils/datepicker";
export default {
  name: "DatePickerCalendarMonth",
  emits: ["custom-date", "hover-date", "click-date", "switch-to-custom", "enableCustomMode", "setDatePickerState"],
  components: {
    DatePickerCalendarMonthLayout,
    DateValue
  },
  expose: ["firstMonth", "lastMonth"],
  props: {
    range: {
      type: Object,
      default: () => {}
    },
    compare: {
      type: Object,
      default: () => {}
    },
    showDays: {
      type: Boolean,
      default: true
    },
    highlightToday: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isRangeCustom: {
      type: Boolean,
      default: false
    },
    isCompareCustom: {
      type: Boolean,
      default: false
    },
    hoverDate: {
      type: Object,
      default: () => {}
    },
    monthList: {
      type: Array,
      default: () => []
    },
    state: {
      type: Object
    },
    weekType: {
      type: String,
      default: "monday"
    },
    datesMap: {
      type: Map
    }
  },
  computed: {
    dateClass() {
      return (date, month, year) => this.getDayDateClass(date, month, year);
    },
    hoverColor() {
      // Blue: Compare.Custom incomplete AND range is complete
      const isCompareFilling = this.state?.compareType === DATE_PICKER_COMPARE_TITLES.CUSTOM && !this.state?.compareIsComplete && this.state?.rangeIsComplete;
      return isCompareFilling ? 'var(--color-semantic-blue-500, #669eff)' : 'var(--market-800)';
    }
  },
  data() {
    return {
      firstMonth: null,
      lastMonth: null
    };
  },
  mixins: [DatePickerCalendarMixin]
};